
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree935"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree935"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $07c2e165ad7bac57$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["8jj1W","dome.180c35aa.js","TLCOp","bomb.e2ff4896.wav"]'));

var $fa4cdc5e54ed440d$export$8d01c972ee8b14a9 = /** @class */ function() {
    function Canvas() {
        var canvas = document.getElementById("canvas");
        this.canvas = canvas;
        this.contextCanvas = canvas.getContext("2d");
        this.width = 1600;
        this.height = 800;
        this.startCityX = this.width - this.width / 3.5;
        this.startCityY = this.height - 3;
    }
    Canvas.prototype.renderCity = function() {
        this.contextCanvas.beginPath();
        this.contextCanvas.fillStyle = "#22ffff";
        this.contextCanvas.fillRect(this.startCityX, this.startCityY, 300, 3);
        this.contextCanvas.closePath();
    };
    Canvas.prototype.render = function() {
        this.renderCity();
    };
    return Canvas;
}();


var $0c83e9867a6050d9$exports = {};
$0c83e9867a6050d9$exports = new URL("bomb.e2ff4896.wav", import.meta.url).toString();


var $3d149cbc210b66cc$var$defaultSpeed = 0.06;
var $3d149cbc210b66cc$var$minHeightToFlight = 30;
var $3d149cbc210b66cc$var$TIME_IN_MS_TO_FINISH_ANIMATE_EXPLOSION = 2000;
var $3d149cbc210b66cc$export$2868ee9a20f77d25 = /** @class */ function() {
    function DefenseMissiles(canvas, HostileArtifacts) {
        this.canvas = canvas;
        this.audio = new Audio();
        this.audio.src = (0, (/*@__PURE__*/$parcel$interopDefault($0c83e9867a6050d9$exports)));
        this.audio.volume = 0.5;
        this.explosionFinished = false;
        this.target = HostileArtifacts;
        this.velocityX = 0;
        this.velocityY = 1;
        this.missionIsDone = false;
        this.color = "#ddff33";
        this.isFullLocked = false;
        this.hasAlreadyTakenOffAboveMinimumHeight = false;
        this.x = this.canvas.width - this.canvas.width / 4 + Math.random() * 10;
        this.y = 0;
        this.id = new Date().getTime();
    }
    DefenseMissiles.prototype.explode = function(explodeTarget) {
        var _this = this;
        if (explodeTarget) this.target.explode();
        this.missionIsDone = true;
        var timeToAudioInMs = 900;
        setTimeout(function() {
            _this.audio.play();
        }, timeToAudioInMs);
    };
    DefenseMissiles.prototype.renderDefenseMissile = function() {
        this.canvas.contextCanvas.beginPath();
        this.canvas.contextCanvas.fillStyle = this.isFullLocked ? "#22ffff" : this.color;
        var width = this.isFullLocked ? 3 : 2;
        var height = this.isFullLocked ? 3 : 2;
        this.canvas.contextCanvas.fillRect(this.x, this.canvas.height - this.y, width, height);
        this.canvas.contextCanvas.closePath();
    };
    DefenseMissiles.prototype.renderExplosion = function() {
        this.canvas.contextCanvas.beginPath();
        this.canvas.contextCanvas.fillStyle = "#ffffff";
        this.canvas.contextCanvas.fillRect(this.x, this.canvas.height - this.y, 8, 8);
        this.canvas.contextCanvas.closePath();
    };
    DefenseMissiles.prototype.updateVelocityX = function(newVelocity) {
        this.velocityX += newVelocity;
        if (this.velocityX > 1.65) this.velocityX = 1.65;
        else if (this.velocityX < -1.65) this.velocityX = -1.65;
    };
    DefenseMissiles.prototype.updateVelocityY = function(newVelocity) {
        this.velocityY += newVelocity;
        if (this.velocityY > 1.65) this.velocityY = 1.65;
        else if (this.velocityY < -1.65) this.velocityY = -1.65;
    };
    DefenseMissiles.prototype.trackArtefact = function() {
        if (!this.target.isGoing) return;
        var deltaX = this.target.x - this.x;
        var deltaY = this.target.y - this.y;
        var distanceToAttachInHorizontal = 400;
        if (deltaX > 0) {
            if (deltaX > distanceToAttachInHorizontal) {
                this.updateVelocityX($3d149cbc210b66cc$var$defaultSpeed / 5);
                this.isFullLocked = false;
            } else {
                this.updateVelocityX($3d149cbc210b66cc$var$defaultSpeed);
                this.isFullLocked = true;
            }
        } else if (deltaX < 0) {
            if (deltaX < distanceToAttachInHorizontal * -1) {
                this.updateVelocityX($3d149cbc210b66cc$var$defaultSpeed / 5 * -1);
                this.isFullLocked = false;
            } else {
                this.updateVelocityX($3d149cbc210b66cc$var$defaultSpeed * -1);
                this.isFullLocked = true;
            }
        }
        if (deltaY > 0) this.updateVelocityY($3d149cbc210b66cc$var$defaultSpeed);
        else if (deltaY < 0) this.updateVelocityY($3d149cbc210b66cc$var$defaultSpeed * -1);
        this.y += this.velocityY;
        this.x += this.velocityX;
    };
    DefenseMissiles.prototype.render = function() {
        var _this = this;
        if (this.explosionFinished) return;
        if (this.missionIsDone) {
            this.renderExplosion();
            setTimeout(function() {
                _this.explosionFinished = true;
            }, $3d149cbc210b66cc$var$TIME_IN_MS_TO_FINISH_ANIMATE_EXPLOSION);
            return;
        }
        if (!this.hasAlreadyTakenOffAboveMinimumHeight && this.y > $3d149cbc210b66cc$var$minHeightToFlight) this.hasAlreadyTakenOffAboveMinimumHeight = true;
        this.trackArtefact();
        this.renderDefenseMissile();
        var targetX = Math.abs(this.target.x - this.x);
        var targetY = Math.abs(this.target.y - this.y);
        var explodeTarget = targetX + targetY <= 10;
        if (explodeTarget || !this.target.isGoing || this.hasAlreadyTakenOffAboveMinimumHeight && this.y < $3d149cbc210b66cc$var$minHeightToFlight) this.explode(explodeTarget);
    };
    return DefenseMissiles;
}();


var $ec0bf2b6bf4eb40a$var$minHeightToFlight = 30;
var $ec0bf2b6bf4eb40a$export$d5e35cb93627922 = /** @class */ function() {
    function RadarSystem(hostileArtifacts, canvas) {
        this.canvas = canvas;
        this.defenseMissilesByIdHostileArtifacts = {};
        this.hostileArtifacts = hostileArtifacts;
        this.hostileArtifactsDetected = [];
    }
    RadarSystem.prototype.launchDefensibleMissile = function(hostileArtifact) {
        this.defenseMissilesByIdHostileArtifacts[hostileArtifact.id] = new (0, $3d149cbc210b66cc$export$2868ee9a20f77d25)(this.canvas, hostileArtifact);
    };
    RadarSystem.prototype.findDefensibleMissileDestroyedAndFix = function() {
        var _this = this;
        this.hostileArtifacts.forEach(function(hostileArtifact) {
            if (hostileArtifact.isGoing && hostileArtifact.y > $ec0bf2b6bf4eb40a$var$minHeightToFlight) {
                if (_this.defenseMissilesByIdHostileArtifacts[hostileArtifact.id].missionIsDone) _this.launchDefensibleMissile(hostileArtifact);
            }
        });
    };
    RadarSystem.prototype.render = function() {
        var _this = this;
        this.hostileArtifacts.forEach(function(hostileArtifact) {
            var artifactAreDetected = _this.hostileArtifactsDetected.includes(hostileArtifact.id);
            if (!artifactAreDetected) {
                _this.launchDefensibleMissile(hostileArtifact);
                _this.hostileArtifactsDetected.push(hostileArtifact.id);
            }
        });
        this.hostileArtifactsDetected.forEach(function(hostileArtifactsId) {
            var _a, _b;
            (_b = (_a = _this.defenseMissilesByIdHostileArtifacts) === null || _a === void 0 ? void 0 : _a[hostileArtifactsId]) === null || _b === void 0 || _b.render();
        });
        this.findDefensibleMissileDestroyedAndFix();
    };
    return RadarSystem;
}();


var $2338a30c68c1a1d8$export$6a77e7ef76b918fb = /** @class */ function() {
    function KeyBoardHandler() {
        var _this = this;
        this.keyboardState = {
            Space: false,
            KeyA: false,
            KeyD: false,
            KeyS: false,
            KeyW: false,
            ShiftLeft: false,
            KeyE: false,
            KeyF: false,
            KeyQ: false,
            KeyX: false
        };
        // REFACTOR ME
        var moves = {
            Space: function(newValue) {
                _this.keyboardState.Space = newValue;
            },
            KeyW: function(newValue) {
                _this.keyboardState.KeyW = newValue;
            },
            KeyS: function(newValue) {
                _this.keyboardState.KeyS = newValue;
            },
            KeyA: function(newValue) {
                _this.keyboardState.KeyA = newValue;
            },
            KeyD: function(newValue) {
                _this.keyboardState.KeyD = newValue;
            },
            ShiftLeft: function(newValue) {
                _this.keyboardState.ShiftLeft = newValue;
            },
            KeyE: function(newValue) {
                _this.keyboardState.KeyE = newValue;
            },
            KeyQ: function(newValue) {
                _this.keyboardState.KeyQ = newValue;
            },
            KeyF: function(newValue) {
                _this.keyboardState.KeyF = newValue;
            },
            KeyX: function(newValue) {
                _this.keyboardState.KeyX = newValue;
            }
        };
        window.addEventListener("keydown", function(event) {
            var _a;
            (_a = moves[event.code]) === null || _a === void 0 || _a.call(moves, true);
        });
        window.addEventListener("keyup", function(event) {
            var _a;
            (_a = moves[event.code]) === null || _a === void 0 || _a.call(moves, false);
        });
    }
    return KeyBoardHandler;
}();


function $a0043beef1da4b17$export$a187cfa0983d4faf() {
    var r = Math.floor(Math.random() * 256);
    var g = Math.floor(Math.random() * 256);
    var b = Math.floor(Math.random() * 256);
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
var $a0043beef1da4b17$export$4db111e237e13b39 = function(windSpeed) {
    var newWindSpeed = windSpeed + Math.random() * 10;
    if (newWindSpeed > 110) return 110;
    if (newWindSpeed < -110) return -110;
    return newWindSpeed;
};
var $a0043beef1da4b17$var$GRAVITY = 9.81;
var $a0043beef1da4b17$var$FACTOR_TO_SHOW_INSIDE_CANVAS = 20;
var $a0043beef1da4b17$export$20ce9a84b2a4cf2a = function(elapsedTime, horizontalSpeedInitial, verticalSpeedInitial, windSpeed) {
    var horizontalSpeedCorrected = horizontalSpeedInitial + windSpeed;
    var x = horizontalSpeedCorrected * elapsedTime;
    var y = verticalSpeedInitial * elapsedTime - 0.5 * $a0043beef1da4b17$var$GRAVITY * elapsedTime * elapsedTime;
    return {
        x: Math.floor(x / $a0043beef1da4b17$var$FACTOR_TO_SHOW_INSIDE_CANVAS),
        y: Math.floor(y / $a0043beef1da4b17$var$FACTOR_TO_SHOW_INSIDE_CANVAS)
    };
};



var $614c1c60df8d33ac$var$TIME_IN_MS_TO_FINISH_ANIMATE_EXPLOSION = 2000;
var $614c1c60df8d33ac$var$FACTOR_TO_UPPER_MOVEMENT_TIME = 10;
var $614c1c60df8d33ac$export$e2278f6542619227 = /** @class */ function() {
    function HostileArtifact(canvas, _a) {
        var color = _a.color, horizontalSpeedInitial = _a.horizontalSpeedInitial, verticalSpeedInitial = _a.verticalSpeedInitial, startX = _a.startX;
        this.canvas = canvas;
        this.color = color;
        this.horizontalSpeedInitial = horizontalSpeedInitial;
        this.verticalSpeedInitial = verticalSpeedInitial;
        this.elapsedTime = 0;
        this.isGoing = true;
        this.finishExplosion = false;
        this.startX = startX;
        this.startY = 0;
        this.x = 0;
        this.y = 0;
        this.id = new Date().getTime();
    }
    HostileArtifact.prototype.explode = function() {
        var _this = this;
        this.isGoing = false;
        setTimeout(function() {
            _this.finishExplosion = true;
        }, $614c1c60df8d33ac$var$TIME_IN_MS_TO_FINISH_ANIMATE_EXPLOSION);
    };
    HostileArtifact.prototype.renderPosition = function() {
        this.elapsedTime += 0.01;
        this.canvas.contextCanvas.beginPath();
        this.canvas.contextCanvas.fillStyle = "#ffffff";
        this.canvas.contextCanvas.fillRect(this.x, this.canvas.height - this.y, 2, 2);
        this.canvas.contextCanvas.closePath();
    };
    HostileArtifact.prototype.renderExplosion = function() {
        this.canvas.contextCanvas.beginPath();
        this.canvas.contextCanvas.fillStyle = "#ff7722";
        this.canvas.contextCanvas.fillRect(this.x, this.canvas.height - this.y, 8, 8);
        this.canvas.contextCanvas.closePath();
    };
    HostileArtifact.prototype.render = function(windSpeed) {
        if (this.finishExplosion) return;
        var position = (0, $a0043beef1da4b17$export$20ce9a84b2a4cf2a)(this.elapsedTime * $614c1c60df8d33ac$var$FACTOR_TO_UPPER_MOVEMENT_TIME, this.horizontalSpeedInitial, this.verticalSpeedInitial, windSpeed);
        this.y = position.y + this.startY;
        this.x = position.x + this.startX;
        var timeToConsiderAreStarted = 2;
        var minHeightToExplode = 5;
        if (this.isGoing && this.elapsedTime > timeToConsiderAreStarted && position.y <= minHeightToExplode) this.explode();
        if (this.isGoing) {
            this.renderPosition();
            return;
        }
        var HostileArtifactsAsLaunched = this.elapsedTime !== 0;
        if (HostileArtifactsAsLaunched && !this.finishExplosion) this.renderExplosion();
    };
    return HostileArtifact;
}();



var $b41dc82d3805874d$export$9680a05d49391975 = function(canvas, startX) {
    var hostileArtifact = new (0, $614c1c60df8d33ac$export$e2278f6542619227)(canvas, {
        color: (0, $a0043beef1da4b17$export$a187cfa0983d4faf)(),
        horizontalSpeedInitial: 150 + (Math.random() - 15),
        verticalSpeedInitial: 500 + (Math.random() - 0.5) + (Math.random() > 0.7 ? Math.random() * 150 : 0),
        startX: startX
    });
    return hostileArtifact;
};


var $994c842d8db8cef0$var$TIME_IN_MS_TO_FINISH_ANIMATE_EXPLOSION = 2000;
var $994c842d8db8cef0$var$velocityBase = 0.1;
var $994c842d8db8cef0$export$fc6f266806565d4e = /** @class */ function() {
    function HostileArtifactControlled(canvas, _a) {
        var color = _a.color, keyState = _a.keyState, horizontalSpeedInitial = _a.horizontalSpeedInitial, verticalSpeedInitial = _a.verticalSpeedInitial, startX = _a.startX;
        this.canvas = canvas;
        this.color = color;
        this.keyState = keyState;
        this.horizontalSpeedInitial = horizontalSpeedInitial;
        this.verticalSpeedInitial = verticalSpeedInitial;
        this.elapsedTime = 0;
        this.isGoing = true;
        this.finishExplosion = false;
        this.velocityX = $994c842d8db8cef0$var$velocityBase;
        this.velocityY = $994c842d8db8cef0$var$velocityBase;
        this.startX = startX;
        this.startY = 0;
        this.x = 0;
        this.y = 0;
        this.id = new Date().getTime();
    }
    HostileArtifactControlled.prototype.explode = function() {
        var _this = this;
        this.isGoing = false;
        this.velocityX = 0;
        this.velocityY = 0;
        setTimeout(function() {
            _this.finishExplosion = true;
        }, $994c842d8db8cef0$var$TIME_IN_MS_TO_FINISH_ANIMATE_EXPLOSION);
    };
    HostileArtifactControlled.prototype.renderPosition = function() {
        this.elapsedTime += 0.01;
        this.canvas.contextCanvas.beginPath();
        this.canvas.contextCanvas.fillStyle = "#ffffff";
        this.canvas.contextCanvas.fillRect(this.x, this.canvas.height - this.y, 2, 2);
        this.canvas.contextCanvas.closePath();
    };
    HostileArtifactControlled.prototype.renderExplosion = function() {
        this.canvas.contextCanvas.beginPath();
        this.canvas.contextCanvas.fillStyle = "#ff7722";
        this.canvas.contextCanvas.fillRect(this.x, this.canvas.height - this.y, 8, 8);
        this.canvas.contextCanvas.closePath();
    };
    HostileArtifactControlled.prototype.updateVelocity = function() {
        if (!this.isGoing) return;
        if (this.keyState.keyboardState.KeyD) this.velocityX += $994c842d8db8cef0$var$velocityBase;
        if (this.keyState.keyboardState.KeyA) this.velocityX -= $994c842d8db8cef0$var$velocityBase;
        if (this.keyState.keyboardState.KeyW) this.velocityY += $994c842d8db8cef0$var$velocityBase;
        if (this.keyState.keyboardState.KeyS) this.velocityY -= $994c842d8db8cef0$var$velocityBase;
        if (this.velocityX > 1.4) this.velocityX = 1.4;
        else if (this.velocityX < -1.4) this.velocityX = -1.4;
        if (this.velocityY > 1.4) this.velocityY = 1.4;
        else if (this.velocityY < -1.4) this.velocityY = -1.4;
    };
    HostileArtifactControlled.prototype.render = function() {
        if (this.finishExplosion) return;
        this.updateVelocity();
        this.x += this.velocityX;
        this.y += this.velocityY;
        if (this.isGoing) {
            this.renderPosition();
            return;
        }
        var HostileArtifactsAsLaunched = this.elapsedTime !== 0;
        if (HostileArtifactsAsLaunched && !this.finishExplosion) this.renderExplosion();
    };
    return HostileArtifactControlled;
}();


var $354f947079a076cf$exports = {};

$parcel$export($354f947079a076cf$exports, "InteractionHandler", () => $354f947079a076cf$export$a30cd982b4e89bdb);
var $354f947079a076cf$var$__assign = undefined && undefined.__assign || function() {
    $354f947079a076cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $354f947079a076cf$var$__assign.apply(this, arguments);
};
var $354f947079a076cf$export$a30cd982b4e89bdb = /** @class */ function() {
    function InteractionHandler(canvas, keyBoardHandler) {
        var _this = this;
        this.canvas = canvas;
        this.keyBoardHandler = keyBoardHandler;
        this.keyboardState = keyBoardHandler.keyboardState;
        this.lastXClick = 0;
        this.lastYClick = 0;
        canvas.canvas.addEventListener("touchstart", function(event) {
            return _this.handleTouchStart(event);
        }, false);
        canvas.canvas.addEventListener("mousedown", function(event) {
            return _this.handleMouseDown(event);
        }, false);
    }
    InteractionHandler.prototype.handleTouchStart = function(event) {
        this.getCanvasCoordinates(event);
        console.log("Touch started at x: ".concat(this.lastXClick, ", y: ").concat(this.lastYClick));
    };
    InteractionHandler.prototype.handleMouseDown = function(event) {
        this.getCanvasCoordinates(event);
        console.log("Mouse down at x: ".concat(this.lastXClick, ", y: ").concat(this.lastYClick));
    };
    InteractionHandler.prototype.setUi = function(ui) {
        this.ui = ui;
    };
    InteractionHandler.prototype.resetClick = function() {
        this.lastXClick = 0;
        this.lastYClick = 0;
    };
    InteractionHandler.prototype.getCanvasCoordinates = function(event) {
        var rect = this.canvas.canvas.getBoundingClientRect();
        if (event.touches) {
            this.lastXClick = event.touches[0].clientX - rect.left;
            this.lastYClick = event.touches[0].clientY - rect.top;
        } else {
            this.lastXClick = event.clientX - rect.left;
            this.lastYClick = event.clientY - rect.top;
        }
    };
    InteractionHandler.prototype.hasCollision = function(keyName) {
        var insideXPosition = this.lastXClick >= this.ui.positions[keyName].x && this.lastXClick <= this.ui.positions[keyName].x + this.ui.positions[keyName].width;
        var insideYPosition = this.lastYClick >= this.ui.positions[keyName].y && this.lastYClick <= this.ui.positions[keyName].y + this.ui.positions[keyName].height;
        return insideXPosition && insideYPosition;
    };
    InteractionHandler.prototype.render = function() {
        var newKeyBoardState = $354f947079a076cf$var$__assign({}, this.keyBoardHandler.keyboardState);
        if (this.lastXClick && this.lastYClick) {
            // REFACTOR ME
            if (this.hasCollision("KeyA")) newKeyBoardState.KeyA = true;
            if (this.hasCollision("KeyW")) newKeyBoardState.KeyW = true;
            if (this.hasCollision("KeyD")) newKeyBoardState.KeyD = true;
            if (this.hasCollision("KeyS")) newKeyBoardState.KeyS = true;
            if (this.hasCollision("KeyF")) newKeyBoardState.KeyF = true;
            if (this.hasCollision("KeyQ")) newKeyBoardState.KeyQ = true;
            if (this.hasCollision("KeyE")) newKeyBoardState.KeyE = true;
            if (this.hasCollision("KeyX")) newKeyBoardState.KeyX = true;
        }
        this.resetClick();
        this.keyboardState = newKeyBoardState;
    };
    return InteractionHandler;
}();


var $70f93982380ff3b5$export$ce6abdcfcf17abde = /** @class */ function() {
    function Ui(canvas, keyboardState) {
        this.canvas = canvas;
        this.keyboardState = keyboardState;
        this.hidden = false;
        this.previneMultiplesActions = false;
        this.positions = {
            KeyX: {
                x: 0,
                y: 0,
                height: 40,
                width: 40
            }
        };
    }
    Ui.prototype.handleHiddenPartialUi = function() {
        this.hidden = true;
    };
    Ui.prototype.handleShowFullUi = function() {
        this.hidden = false;
    };
    Ui.prototype.renderButton = function(_a) {
        var text = _a.text, x = _a.x, y = _a.y, xText = _a.xText, yText = _a.yText, isActive = _a.isActive;
        if (isActive) {
            this.canvas.contextCanvas.fillStyle = "#11ffff";
            this.canvas.contextCanvas.fillRect(x, y, 40, 40);
        } else {
            this.canvas.contextCanvas.strokeStyle = "#11ffff";
            this.canvas.contextCanvas.lineWidth = 3;
            this.canvas.contextCanvas.rect(x, y, 40, 40);
            this.canvas.contextCanvas.stroke();
        }
        this.canvas.contextCanvas.fillStyle = isActive ? "#000000" : "#11ffff";
        this.canvas.contextCanvas.font = "bold 24px Verdana";
        this.canvas.contextCanvas.textAlign = "center";
        this.canvas.contextCanvas.fillText(text, xText, yText);
    };
    Ui.prototype.renderTextUi = function(text, x, y) {
        this.canvas.contextCanvas.fillStyle = "#ff2211";
        this.canvas.contextCanvas.font = "medium 24px Verdana";
        this.canvas.contextCanvas.textAlign = "center";
        this.canvas.contextCanvas.fillText(text, x, y);
    };
    Ui.prototype.optionShowUi = function(height) {
        this.canvas.contextCanvas.beginPath();
        this.renderTextUi("ESCONDER UI", this.canvas.width - 300 - 40, height);
        var startTutorialKey = this.canvas.width - 300 + 90;
        this.positions.KeyX = {
            x: startTutorialKey - 20,
            y: height - 30,
            height: 40,
            width: 40
        };
        this.renderButton({
            isActive: this.keyboardState.keyboardState.KeyX,
            x: this.positions.KeyX.x,
            y: this.positions.KeyX.y,
            text: "x",
            xText: startTutorialKey,
            yText: height
        });
        this.canvas.contextCanvas.closePath();
    };
    Ui.prototype.traceRocket = function(height) {
        this.canvas.contextCanvas.beginPath();
        this.renderTextUi("RASTRO", this.canvas.width - 300, height);
        var startTutorialKey = this.canvas.width - 300 + 90;
        this.positions.KeyF = {
            x: startTutorialKey - 20,
            y: height - 30,
            height: 40,
            width: 40
        };
        this.renderButton({
            text: "f",
            x: startTutorialKey - 20,
            y: height - 30,
            isActive: false,
            xText: startTutorialKey,
            yText: height
        });
        this.canvas.contextCanvas.closePath();
    };
    Ui.prototype.randomArtifact = function(height) {
        this.canvas.contextCanvas.beginPath();
        this.renderTextUi("ARTEFATO ALEATORIO", this.canvas.width - 398, height);
        var startTutorialKey = this.canvas.width - 300 + 90;
        this.positions.KeyE = {
            x: startTutorialKey - 20,
            y: height - 30,
            height: 40,
            width: 40
        };
        this.renderButton({
            text: "e",
            x: startTutorialKey - 20,
            y: height - 30,
            isActive: this.keyboardState.keyboardState.KeyE,
            xText: startTutorialKey,
            yText: height
        });
        this.canvas.contextCanvas.closePath();
    };
    Ui.prototype.controlledArtefact = function(height) {
        this.canvas.contextCanvas.beginPath();
        this.renderTextUi("ARTEFATO CONTROLADO", this.canvas.width - 412, height);
        var startTutorialKey = this.canvas.width - 300 + 90;
        this.positions.KeyQ = {
            x: startTutorialKey - 20,
            y: height - 30,
            height: 40,
            width: 40
        };
        this.renderButton({
            text: "q",
            x: startTutorialKey - 20,
            y: height - 30,
            isActive: this.keyboardState.keyboardState.KeyQ,
            xText: startTutorialKey,
            yText: height
        });
        this.canvas.contextCanvas.closePath();
    };
    Ui.prototype.renderKey = function(text, startTutorialKey, height, isActive, action) {
        this.positions[action] = {
            x: startTutorialKey - 20,
            y: height + 50 - 30,
            height: 40,
            width: 40
        };
        this.renderButton({
            text: text,
            x: startTutorialKey - 20,
            y: height + 50 - 30,
            isActive: isActive,
            xText: startTutorialKey,
            yText: height + 50
        });
    };
    Ui.prototype.optionControlForControlledArtefact = function(height) {
        this.canvas.contextCanvas.beginPath();
        this.renderTextUi("CONTROLAR ARTEFATO", this.canvas.width - 340, height);
        this.renderKey("W", this.canvas.width - 450 + 100, height, this.keyboardState.keyboardState.KeyW, "KeyW");
        this.renderKey("A", this.canvas.width - 450 + 50, height + 50, this.keyboardState.keyboardState.KeyA, "KeyA");
        this.renderKey("D", this.canvas.width - 450 + 148, height + 50, this.keyboardState.keyboardState.KeyD, "KeyD");
        this.renderKey("S", this.canvas.width - 450 + 100, height + 100, this.keyboardState.keyboardState.KeyS, "KeyS");
        this.canvas.contextCanvas.closePath();
    };
    Ui.prototype.render = function() {
        var _this = this;
        if (this.keyboardState.keyboardState.KeyX && !this.previneMultiplesActions) {
            this.previneMultiplesActions = true;
            this.hidden = !this.hidden;
            var TIME_IN_MS_TO_PREVINE_MULTIPLES_TOUCHS = 200;
            setTimeout(function() {
                _this.previneMultiplesActions = false;
            }, TIME_IN_MS_TO_PREVINE_MULTIPLES_TOUCHS);
        }
        this.optionShowUi(this.canvas.height / 4 - 50);
        if (this.hidden) return;
        this.traceRocket(this.canvas.height / 4);
        this.randomArtifact(this.canvas.height / 4 + 100);
        this.controlledArtefact(this.canvas.height / 4 + 150);
        this.optionControlForControlledArtefact(this.canvas.height / 4 + 200);
    };
    return Ui;
}();


var $a77ecfb76e8b8641$var$windSpeed = 0;
var $a77ecfb76e8b8641$var$launchControlledMisseble = false;
(function() {
    var canvas = new (0, $fa4cdc5e54ed440d$export$8d01c972ee8b14a9)();
    var keyboardLocal = new (0, $2338a30c68c1a1d8$export$6a77e7ef76b918fb)();
    var interactionHandler = new (0, $354f947079a076cf$exports.InteractionHandler)(canvas, keyboardLocal);
    var hostileArtifacts = [];
    var radarSystem = new (0, $ec0bf2b6bf4eb40a$export$d5e35cb93627922)(hostileArtifacts, canvas);
    var ui = new (0, $70f93982380ff3b5$export$ce6abdcfcf17abde)(canvas, interactionHandler);
    var TIME_IN_MS_TO_PREVINE_MULTIPLES_TOUCHS = 200;
    interactionHandler.setUi(ui);
    var previneMultiplesActions = false;
    var hiddenTrace = true;
    function bootstrap() {
        if (hiddenTrace) canvas.contextCanvas.clearRect(0, 0, canvas.width, canvas.height);
        if (interactionHandler.keyboardState.KeyF && !previneMultiplesActions) {
            hiddenTrace = !hiddenTrace;
            previneMultiplesActions = true;
            setTimeout(function() {
                previneMultiplesActions = false;
            }, TIME_IN_MS_TO_PREVINE_MULTIPLES_TOUCHS);
        }
        ui.render();
        canvas.render();
        radarSystem.render();
        interactionHandler.render();
        $a77ecfb76e8b8641$var$windSpeed = (0, $a0043beef1da4b17$export$4db111e237e13b39)($a77ecfb76e8b8641$var$windSpeed);
        if (interactionHandler.keyboardState.KeyQ) {
            if (!$a77ecfb76e8b8641$var$launchControlledMisseble) {
                $a77ecfb76e8b8641$var$launchControlledMisseble = true;
                hostileArtifacts.push(new (0, $994c842d8db8cef0$export$fc6f266806565d4e)(canvas, {
                    color: "#1177ff",
                    keyState: interactionHandler,
                    horizontalSpeedInitial: 0,
                    verticalSpeedInitial: 5,
                    startX: 100
                }));
                var timeInMsToAllowNewLaunchControlledMissble = 500;
                setTimeout(function() {
                    $a77ecfb76e8b8641$var$launchControlledMisseble = false;
                }, timeInMsToAllowNewLaunchControlledMissble);
            }
        }
        if (interactionHandler.keyboardState.KeyE) hostileArtifacts.push((0, $b41dc82d3805874d$export$9680a05d49391975)(canvas, Math.random() * 350));
        hostileArtifacts.forEach(function(hostileArtifact) {
            hostileArtifact.render($a77ecfb76e8b8641$var$windSpeed);
        });
        requestAnimationFrame(bootstrap);
    }
    requestAnimationFrame(bootstrap);
})();


//# sourceMappingURL=dome.180c35aa.js.map
